import { Context } from 'Context/Context'
import React, { useContext } from 'react'

function NotificationIcon({count, color, size = null}) {
  const {userDetails} = useContext(Context)
  return (
    <div className={'cursor-pointer relative ' + (color ? color : '')}>
         <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className={size ? "" : "lg:w-[26px] w-[22px] h-[22px] lg:h-[26px]"} style={size ? {width: size + 'px', height: size + 'px', display: 'block'} : undefined}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M18 8a6 6 0 1 0-12 0c0 3-1 5-2 6h16c-1-1-2-3-2-6z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.5 17a2.5 2.5 0 0 0 5 0" />
          </svg>
          {(count !== undefined && count !== 0) &&
          (userDetails?.role !== 0 ? 
          <span class={size ? "absolute -top-[7px] -right-[9px] flex w-[15px] h-[15px] truncate" : ("absolute  left-[12px] bottom-[14px] flex  w-[15px]  h-[15px] truncate" + (count < 99 ? " lg:h-[20px] lg:w-[20px]" : " lg:h-[24px] lg:w-[24px]"))}>
            <span class=" absolute b-10 inline-flex h-full w-full rounded-full bg-red-800 opacity-75"></span>
            <span class={"relative inline-flex text-white items-center justify-center rounded-full bg-red-600 " + (size ? " text-[8.5px] h-[15px] w-[15px]" : (" text-[7px] lg:text-xs" + (count < 99 ? " h-[15px] w-[15px]" : " h-[24px] w-[24px]")))}>{count}</span>
        </span>
          :
            <div className='bg-sky-600 text-white p-1 rounded-full w-4 flex justify-center items-center h-4 absolute -top-2 -right-1 text-xs'>
              {count}</div>
          )
        
        }
    </div>
  )
}

export default NotificationIcon